var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../assets/undraw_no_data_re_kwbl.svg"),"alt":"Aucune donnée"}}),_c('p',{staticClass:"empty-title"},[_vm._v("Aucune donnée disponible")]),_c('p',{staticClass:"empty-sub"},[_vm._v(" Veuillez réessayer plus tard ou rafraîchir la page. ")])])
}]

export { render, staticRenderFns }